var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{staticClass:"pa-0 text-center"},[_vm._v("Selecione o tipo de ação")])}
var staticRenderFns = []

export { render, staticRenderFns }